// src/App.tsx
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { BrowserRouter as Router, Route, Routes, Navigate, useLocation } from 'react-router-dom';
import { AppDispatch } from './store';
import { fetchCatalog } from './features/catalog/catalogSlice';

// Import Layout and Pages
import TrackingHead from './components/TrackingHead';
import WhatsAppFloat from './components/WhatsAppFloat';

import HomeV2 from './pages/HomeV2';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import CookiePolicy from './pages/CookiePolicy';
import QuickStart from './pages/QuickStart';

const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};


const App: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    dispatch(fetchCatalog());
  }, [dispatch]);

  return (
    <Router>
      <TrackingHead />
      <ScrollToTop />
      <WhatsAppFloat />
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<HomeV2 />} />
        <Route path="/v2" element={<Navigate to="/" replace />} />
        <Route path="/quick-start" element={<QuickStart />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route path="/cookie-policy" element={<CookiePolicy />} />

        {/* Old flow — redirect to new flow */}
        <Route path="/start" element={<Navigate to="/quick-start" replace />} />
        <Route path="/shirts" element={<Navigate to="/quick-start" replace />} />
        <Route path="/pants" element={<Navigate to="/quick-start" replace />} />
        <Route path="/final-look" element={<Navigate to="/quick-start" replace />} />
        <Route path="/checkout" element={<Navigate to="/quick-start" replace />} />
        <Route path="/looks" element={<Navigate to="/quick-start" replace />} />
        <Route path="/shop" element={<Navigate to="/quick-start" replace />} />
        <Route path="/more" element={<Navigate to="/quick-start" replace />} />
        <Route path="/profile-setup" element={<Navigate to="/quick-start" replace />} />
      </Routes>
    </Router>
  );
};

export default App;